import 'antd/es/avatar/style/css';
import 'antd/es/button/style/css';
import 'antd/es/checkbox/style/css';
import 'antd/es/divider/style/css';
import 'antd/es/empty/style/css';
import 'antd/es/form/style/css';
import 'antd/es/icon/style/css';
import 'antd/es/input/style/css';
import 'antd/es/input-number/style/css';
import 'antd/es/modal/style/css';
import 'antd/es/popconfirm/style/css';
import 'antd/es/result/style/css';
import 'antd/es/select/style/css';
import 'antd/es/spin/style/css';
import 'antd/es/statistic/style/css';
import 'antd/es/steps/style/css';
import 'antd/es/tag/style/css';
import 'antd/es/tooltip/style/css';
import 'antd/es/table/style/css';
import 'antd/es/message/style/css';
import 'antd/es/dropdown/style/css';
import 'antd/es/menu/style/css';
import 'antd/es/switch/style/css';
import 'antd/es/notification/style/css';
export { default as Avatar } from 'antd/es/avatar';
export { default as AutoComplete } from 'antd/es/auto-complete';
export { default as Button } from 'antd/es/button';
export { default as Checkbox } from 'antd/es/checkbox';
export { default as Divider } from 'antd/es/divider';
export { default as Empty } from 'antd/es/empty';
export { default as Form } from 'antd/es/form';
export { default as Icon } from 'antd/es/icon';
export { default as Input } from 'antd/es/input';
export { default as InputNumber } from 'antd/es/input-number';
export { default as Modal } from 'antd/es/modal';
export { default as Popconfirm } from 'antd/es/popconfirm';
export { default as Result } from 'antd/es/result';
export { default as Select } from 'antd/es/select';
export { default as Statistic } from 'antd/es/statistic';
export { default as Steps } from 'antd/es/steps';
export { default as Spin } from 'antd/es/spin';
export { default as Tag } from 'antd/es/tag';
export { default as Tooltip } from 'antd/es/tooltip';
export { default as Table } from 'antd/es/table';
export { default as message } from 'antd/es/message';
export { default as Dropdown } from 'antd/es/dropdown';
export { default as Menu } from 'antd/es/menu';
export { default as Switch } from 'antd/es/switch';
export { default as notification } from 'antd/es/notification';